export enum LetterType {
  Modification = "modificationletter",
  General = "generalletter",
}
